import React from 'react';
import { Paper, Stack, Box, Typography } from '@mui/material';
import { ProposalStatus, DealStatus, UserRoles } from '../../../../utils/enums';
import { format } from 'date-fns';
import { Link } from "react-router-dom";
import UsersMultiAutoComplete from '../../../Users/UsersMultiAutoComplete';

const BasicDetails = ({ data, onAssigneesChange }) => {

    return (
        <Paper elevation={0} sx={{ p: 2 }}>
            <Stack direction="column" alignItems="center" spacing={2}>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Topic:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{data?.topic || '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Amount:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{data?.amount ? `$ ${data.amount}` : '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Proposal Status:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{ProposalStatus[data?.proposalStatus]?.label ?? '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Deal Status:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{DealStatus[data?.dealStatus]?.label ?? '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Deadline:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{data?.deadline ? format(new Date(data.deadline), 'MMMM do yyyy') : '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Date:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{data?.date ? format(new Date(data.date), 'MMMM do yyyy') : '—'}</span>
                    </Box>
                </Box>
                {data?.leadId && (
                    <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                        <Box display="flex" justifyContent="flex-end" width="40%">
                            <span>Lead:</span>
                        </Box>
                        <Box display="flex" justifyContent="flex-start" width="60%">
                            <span style={{ marginLeft: '20px' }}>
                                <Link to={`${'/leads'}/${data?.leadId}`}>
                                    {data?.lead ? `${data.lead.firstName || ''} ${data.lead.lastName || ''}`.trim() : (data?.leadName || 'Lead')}
                                </Link>
                            </span>
                        </Box>
                    </Box>
                )}
                {data?.accountId != null && data.accountId !== 0 && (
                    <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                        <Box display="flex" justifyContent="flex-end" width="40%">
                            <span>Account:</span>
                        </Box>
                        <Box display="flex" justifyContent="flex-start" width="60%">
                            <span style={{ marginLeft: '20px' }}>
                                <Link to={`${'/accounts'}/${data?.accountId}`}>{data?.accountName || 'Account'}</Link>
                            </span>
                        </Box>
                    </Box>
                )}
                {data?.dealId && (
                    <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                        <Box display="flex" justifyContent="flex-end" width="40%">
                            <span>Deal:</span>
                        </Box>
                        <Box display="flex" justifyContent="flex-start" width="60%">
                            <span style={{ marginLeft: '20px' }}>
                                <Link to={`${'/deals'}/${data?.dealId}`}>{data?.dealName || 'Deal'}</Link>
                            </span>
                        </Box>
                    </Box>
                )}
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Assignees:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%" sx={{ paddingLeft: '20px' }}>
                        <Box sx={{ width: '350px' }}>
                            <UsersMultiAutoComplete
                                selectedUserIds={data?.assignTo || []}
                                onAssigneesChange={onAssigneesChange}
                                proposalId={data?.id}
                                small={true}
                                fullWidth={false}
                                role={UserRoles[4].value}
                            />
                        </Box>
                    </Box>
                </Box>
            </Stack>
        </Paper>
    )
}

export default BasicDetails;

